import { twMerge } from 'tailwind-merge';
import {
  IconButton,
  DialogTitle,
  DialogActions,
  DialogContent,
  Dialog as MuiDialog,
} from '@mui/material';

import { Icon } from '../icons';
import { Button } from '../button';

import { DialogProps } from './types';

export const Dialog = ({
  open,
  title,
  onClose,
  actions,
  children,
  className,
  maxWidth = 'sm',
  showCloseButton,
  contentClassName,
}: DialogProps) => {
  return (
    <MuiDialog
      fullWidth
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      slotProps={{
        backdrop: {
          className: 'bg-black-primary/70',
        },
        paper: {
          className: twMerge(
            'mx-4 w-full rounded-3xl md:rounded-4xl shadow-teal-primary/8 shadow-[0px_16px_32px_0px] border-[1.5px] border-gray-primary outline-none',
            className
          ),
        },
      }}
    >
      {title || showCloseButton ? (
        <DialogTitle
          variant="h1"
          className="md:h1-hero relative px-4 pt-4 pb-4 font-medium md:px-6 md:pt-6"
        >
          {title}
          {showCloseButton && (
            <IconButton
              onClick={onClose}
              className="absolute top-4 right-4 p-0 text-black"
            >
              <Icon.Close />
            </IconButton>
          )}
        </DialogTitle>
      ) : null}
      <DialogContent
        className={twMerge('px-4 pb-3 md:px-6 md:pb-4', contentClassName)}
      >
        {children}
      </DialogContent>
      <DialogActions className="px-4 pt-3 pb-4 md:px-6 md:pt-4 md:pb-6">
        {actions ?? (
          <Button color="primary" onClick={onClose}>
            Close
          </Button>
        )}
      </DialogActions>
    </MuiDialog>
  );
};

export type { DialogProps };
